export default [
  {
    label: '电子联行转换中心'
  },
  {
    label: '中国人民银行营业处'
  },
  {
    label: '中国人民银行国库处'
  },
  {
    label: '支付系统收费专户'
  },
  {
    label: '中国工商银行'
  },
  {
    label: '中国农业银行'
  },
  {
    label: '中国银行'
  },
  {
    label: '中国建设银行'
  },
  {
    label: '国家开发银行'
  },
  {
    label: '中国进出口银行'
  },
  {
    label: '中国农业发展银行'
  },
  {
    label: '交通银行'
  },
  {
    label: '中信银行'
  },
  {
    label: '光大银行'
  },
  {
    label: '华夏银行'
  },
  {
    label: '中国民生银行'
  },
  {
    label: '广东发展银行'
  },
  {
    label: '平安银行'
  },
  {
    label: '招商银行'
  },
  {
    label: '福建兴业银行'
  },
  {
    label: '上海浦东发展银行'
  },
  {
    label: '城市商业银行'
  },
  {
    label: '农村商业银行'
  },
  {
    label: '恒丰银行'
  },
  {
    label: '浙商银行'
  },
  {
    label: '农村合作银行'
  },
  {
    label: '渤海银行'
  },
  {
    label: '徽商银行'
  },
  {
    label: '村镇银行'
  },
  {
    label: '三峡银行'
  },
  {
    label: '上海农村商业银行'
  },
  {
    label: '城市信用合作社'
  },
  {
    label: '农村信用合作社'
  },
  {
    label: '邮政储蓄'
  },
  {
    label: '香港上海汇丰银行'
  },
  {
    label: '东亚银行'
  },
  {
    label: '南洋商业银行'
  },
  {
    label: '恒生银行'
  },
  {
    label: '中银香港'
  },
  {
    label: '集友银行'
  },
  {
    label: '廖创兴银行'
  },
  {
    label: '亚洲商业银行'
  },
  {
    label: '道亨银行'
  },
  {
    label: '永亨银行'
  },
  {
    label: '上海商业银行'
  },
  {
    label: '永隆银行'
  },
  {
    label: '大新银行'
  },
  {
    label: '中信嘉华银行'
  },
  {
    label: '国泰世华商业银行'
  },
  {
    label: '台湾土地银行'
  },
  {
    label: '花旗银行'
  },
  {
    label: '美国银行'
  },
  {
    label: '摩根大通银行'
  },
  {
    label: '建东银行'
  },
  {
    label: '美一银行'
  },
  {
    label: '纽约银行'
  },
  {
    label: '三菱东京日联银行'
  },
  {
    label: '日联银行'
  },
  {
    label: '三井住友银行'
  },
  {
    label: '瑞穗实业银行'
  },
  {
    label: '山口银行'
  },
  {
    label: '日本住友信托银行'
  },
  {
    label: '日本横滨银行'
  },
  {
    label: '韩国外换银行'
  },
  {
    label: '朝兴银行'
  },
  {
    label: '友利银行'
  },
  {
    label: '韩国产业银行'
  },
  {
    label: '新韩银行'
  },
  {
    label: '韩国中小企业银行'
  },
  {
    label: '韩亚银行'
  },
  {
    label: '韩国国民银行'
  },
  {
    label: '马来亚银行'
  },
  {
    label: '首都银行及信托公司'
  },
  {
    label: '华侨银行'
  },
  {
    label: '大华银行'
  },
  {
    label: '星展银行'
  },
  {
    label: '盘古银行'
  },
  {
    label: '泰京银行'
  },
  {
    label: '泰华农民银行'
  },
  {
    label: '奥地利中央合作银行'
  },
  {
    label: '比利时联合银行'
  },
  {
    label: '比利时富通银行'
  },
  {
    label: '荷兰银行'
  },
  {
    label: '荷兰商业银行'
  },
  {
    label: '荷兰万贝银行'
  },
  {
    label: '渣打银行'
  },
  {
    label: '苏格兰皇家银行'
  },
  {
    label: '瑞典商业银行公共有限'
  },
  {
    label: '瑞典北欧斯安银行有限'
  },
  {
    label: '法国兴业银行'
  },
  {
    label: '法国巴黎银行'
  },
  {
    label: '东方汇理银行'
  },
  {
    label: '法国里昂信贷银行'
  },
  {
    label: '法国外贸银行'
  },
  {
    label: '德累斯顿银行'
  },
  {
    label: '德意志银行'
  },
  {
    label: '德国商业银行'
  },
  {
    label: '西德意志银行'
  },
  {
    label: '巴伐利亚州银行'
  },
  {
    label: '德国北德意志州银行'
  },
  {
    label: '中德住房储蓄银行'
  },
  {
    label: '罗马银行'
  },
  {
    label: '意大利联合商业银行'
  },
  {
    label: '瑞士信贷第一波士顿'
  },
  {
    label: '瑞士银行有限公司'
  },
  {
    label: '丰业银行'
  },
  {
    label: '蒙特利尔银行'
  },
  {
    label: '澳新银行'
  },
  {
    label: '葡国储蓄信贷银行'
  },
  {
    label: '珠海南通银行'
  },
  {
    label: '宁波国际银行'
  },
  {
    label: '新联商业银行'
  },
  {
    label: '协和银行'
  },
  {
    label: '德富泰银行有限公司'
  },
  {
    label: '荷兰合作银行中国公司'
  },
  {
    label: '厦门国际银行'
  },
  {
    label: '上海-巴黎国际银行'
  },
  {
    label: '福建亚洲银行'
  },
  {
    label: '浙江商业银行'
  },
  {
    label: '华商银行'
  },
  {
    label: '青岛国际银行'
  },
  {
    label: '华一银行'
  },
  {
    label: '华美银行中国有限公司'
  },
  {
    label: '中央国债登记结算公司'
  },
  {
    label: '人民银行公开市场操作'
  },
  {
    label: '外汇交易中心'
  },
  {
    label: '城市商业银行资金清算'
  },
  {
    label: '中国银联股份有限公司'
  },
  {
    label: '代收付清算组织'
  },
  {
    label: '财务公司'
  },
  {
    label: '上海清算所'
  },
  {
    label: '澳门清算行'
  },
  {
    label: '香港人民币清算行'
  },
  {
    label: '票交所'
  },
  {
    label: '其他银行'
  },
  {
    label: '民营银行'
  },
  {
    label: '上海银行'
  }
]
